import React from "react";
import { Box } from "@mui/material";
import GENERAL_FORM_MODULE from "../../../../main_components/material_table/general_form_module";
import { useEffect, useMemo, useRef, useState } from 'react';
import { inf_partner } from "./inf_partner";
import { BREADCRUMBS } from "../../../../main_components/pagination/breadcrumbs";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import {
    updated_form_data,
    validate_data,
    processed_format,
} from "./auxiliar_funtions";
import MODAL_TABLE from "../../../../main_components/modal/modal_Table";
import { code_businesspartners_get, bussines_partnert_post } from "../../../../services/businesspartners/businesspartners";
export default function CUSTOM_QR_PARTNER() {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [modalT, setmodalT] = useState<boolean>(false);
    const [open_form, setopen_form] = useState(false);
    const [isNewEntry, setIsNewEntry] = useState(false);
    const [formData, setformData] = useState([]);
    const [methodDelete, setMethodDelete] = useState(false);
    const [loadingSkeleton, setLoadingSkeleton] = useState<boolean>(false);

    const [identifier_data, setidentifier_data] = useState<any>([]);
    const navigate = useNavigate();

    const location = useLocation();
    const { myObject } = location.state || {};

    console.log(myObject); // Aquí tienes los datos que pasaste

    useEffect(() => {
        if (myObject) {
            console.log("Objeto recibido:", myObject);

            handleAddCode(myObject, true);
        } else {
            console.log("No se recibió ningún objeto.");
        }
    }, []);


    const fetchCodePartner = async () => {
        try {
            const response = await code_businesspartners_get();
            return response.data.code;
        } catch (error) {
            console.error("Error al obtener el código del socio:", error);
            return [];
        }
    };
    const handleAddCode = async (originalObj: any, isNew: boolean) => {
        setLoadingSkeleton(true);
        try {
            const code = await fetchCodePartner();


            originalObj.code = code;

            setformData(originalObj)
            setIsNewEntry(true)
            setopen_form(true);
            setMethodDelete(false);
            setLoadingSkeleton(false);
        } catch (error) {
            console.error("Error al manejar add_address_bp:", error);
            setLoadingSkeleton(false);

            return null;
        }
    };


    const update_identifiers = [
        { id: "string" },
        { description: "string" },
        { term: "String" },
    ];


    const handle_open_form = (new_value: any, isNew: boolean) => {
        setformData(new_value)
        setIsNewEntry(isNew);
        setopen_form(true);
        setMethodDelete(false)
    };

    const handle_close = () => {
        setopen_form(false);
    };





    const handleSaveData = async (
        finalObject: any,
        method: any,
        identifier_data: any
    ) => {
        console.log("Datos a procesar:", finalObject);
        console.log("True / Post, False / Put, Delete:", method);

        setmodalT(true);

        try {
            switch (method) {
                case true:
                    console.log("Creando objeto...");
                    await bussines_partnert_post(finalObject);
                    console.log("Objeto creado con éxito");
                    setmodalT(false);
                    navigate('/BUSSINES_PARTNER_TS');

                    break;

                default:
                    console.error("Método no reconocido");
            }
        } catch (error: any) {
            alert(error.response.data.errorMessage.es);
            console.error("Error al procesar los datos:", error);
            setmodalT(false);

        } finally {

            console.log("Operación finalizada.");
        }
    };

    return (
        <Box>
            <BREADCRUMBS niveles={
                [
                    { label: "CREAR SOCIO DE NEGOCIOS", path: null },
                ]
            }
            ></BREADCRUMBS>
            <MODAL_TABLE
                open={false}
                modalT={modalT}
                modalGeneral={false}
                message={"Creando..."}
                message2={"Creando..."}
            ></MODAL_TABLE>

            <GENERAL_FORM_MODULE
                open={open_form}
                onClose={handle_close}
                data_form={inf_partner}
                onSave={handleSaveData}
                isNew={isNewEntry}
                title_create="CREAR SOCIO DE NEGOCIOS"
                title_update="ACTUALIZAR CONDICIONES DE PAGOS"
                validateField={validate_data}
                handleProcessedFormat={processed_format}
                FormData={FormData} // Este también parece que debería ser `formData` (ojo con mayúsculas)
                original_data={formData}
                size={methodDelete ? "30%" : "100%"}
                methodDelete={methodDelete}
                message_delete="¿Esta seguro de eliminar esta condición de pago?"
                updatedFormData={updated_form_data}
                identifier_data={identifier_data}
                loadingSkeleton={loadingSkeleton}
                methodCustom={false}
            />



        </Box>
    );
}
